/* unplugin-vue-components disabled */import { render } from "./NotificationFooterList.vue?vue&type=template&id=42b0c182&scoped=true&ts=true"
import script from "./NotificationFooterList.vue?vue&type=script&lang=ts"
export * from "./NotificationFooterList.vue?vue&type=script&lang=ts"

import "./NotificationFooterList.vue?vue&type=style&index=0&id=42b0c182&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b0c182"]])

export default __exports__